module.exports = __webpack_public_path__ + "service_image_assistance_technique.png?1db654e650d9c71574e85f399a80d1d4";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/service_image_assistance_technique.png
// module id = 288
// module chunks = 0